export const ZH_TW = 'zh_TW';
export const EN = 'en';
const JA = 'ja';

// 'Azərbaycanca' as developer language
const DEV = 'az';

// Default locale
export const DEFAULT_LOCALE = EN;

export default { ZH_TW, EN, JA, DEV };
